// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelGeneral_jMnF5 {
  display: flex;
  padding: 11px 0px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #ebebeb;
}
.deleteChatsContainer_NCk3w {
  width: 80%;
  background-color: var(--white-background);
  margin: 0 auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  p {
    margin: 0;
    color: #38343d;
  }
  .password_dRpg9 {
    display: flex;
    align-items: center;
    span,
    > div {
      flex: 1 1;
    }
    > div {
      input {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px;
        background-color: var(--f4-background);
        border-radius: 5px;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
      }
      span {
        color: #b40e1b;
        font-size: 13px;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/DataControls/DataControls.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB;;MAEE,SAAO;IACT;IACA;MACE;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,sCAAsC;QACtC,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,aAAa;MACf;MACA;QACE,cAAc;QACd,eAAe;MACjB;IACF;EACF;AACF","sourcesContent":[".labelGeneral {\n  display: flex;\n  padding: 11px 0px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-bottom: 1px solid #ebebeb;\n}\n.deleteChatsContainer {\n  width: 80%;\n  background-color: var(--white-background);\n  margin: 0 auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  p {\n    margin: 0;\n    color: #38343d;\n  }\n  .password {\n    display: flex;\n    align-items: center;\n    span,\n    > div {\n      flex: 1;\n    }\n    > div {\n      input {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        box-sizing: border-box;\n        width: 100%;\n        padding: 12px;\n      }\n      span {\n        color: #b40e1b;\n        font-size: 13px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelGeneral": `labelGeneral_jMnF5`,
	"deleteChatsContainer": `deleteChatsContainer_NCk3w`,
	"password": `password_dRpg9`
};
export default ___CSS_LOADER_EXPORT___;
